import React from 'react';
import { Skeleton } from 'antd';

import CommonLightCard from '@/common/components/light-card';

export default function LightCard() {
  return (
    <CommonLightCard onClick={() => {}}>
      <CommonLightCard.Body className="w-full !flex-row items-center justify-between">
        <CommonLightCard.Item>
          <CommonLightCard.Icon className="overflow-hidden">
            <Skeleton.Image className="small-image-skeleton w-9" active />
          </CommonLightCard.Icon>
          <CommonLightCard.Title className="!text-sm !font-semibold">
            <Skeleton.Input active size="small" className="!w-9" />
          </CommonLightCard.Title>
        </CommonLightCard.Item>
        <CommonLightCard.Item>
          <Skeleton.Button active />
        </CommonLightCard.Item>
      </CommonLightCard.Body>
    </CommonLightCard>
  );
}
